import React from 'react';
import { useTheme } from 'styled-components';

// import { ReactComponent as CalenderSVG } from '../../assets/icons/calendar.svg';
// import { ReactComponent as FilterSVG } from '../../assets/icons/Filter.svg';
import { ReactComponent as LensSVG } from '../../assets/icons/search.svg';
// import { useResponsive } from '../../hooks/useResponsive';
// import { FilterButton } from '../Button';
import Input from '../Input';
// import Popover from '../Popover';
import Typography from '../Typography';
import { FilterWrapper, TitleFilterContainer } from './style';

type Props = {
  handleOnSearchTextChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  filterAction?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  dateFilterAction?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onLensClick?: (e: React.MouseEvent<SVGElement>) => void;
  search?: string;
  pageTitle: React.ReactNode;
  otherActions?: React.ReactNode;
  filterContent?: React.ReactNode;
  dateFilterContent?: React.ReactNode;
  showSearch?: boolean;
  showFilter?: boolean;
  showDateFilter?: boolean;
  maxWidthBreakPoint?: string;
  width?: string;
};
const PageHeader = ({
  handleOnSearchTextChange,
  pageTitle,
  search,
  // dateFilterAction,
  // filterAction,
  onLensClick,
  otherActions,
  showDateFilter = true,
  // showFilter = true,
  showSearch = true,
  // dateFilterContent,
  // filterContent,
  maxWidthBreakPoint = '768px',
  // width,
}: Props) => {
  // const { isLargeMobile } = useResponsive();
  const theme = useTheme();

  const renderAddFilterBtn = (className: string) =>
    otherActions ? <div className={className}>{otherActions} </div> : '';

  return (
    <TitleFilterContainer $maxWidthBreakPoint={maxWidthBreakPoint}>
      <div className="title-wrapper">
        {!!pageTitle &&
          (typeof pageTitle === 'string' ? (
            <Typography variant="title">{pageTitle}</Typography>
          ) : (
            pageTitle
          ))}
        {renderAddFilterBtn('head-other-actions')}
      </div>

      {(showDateFilter || showDateFilter || showSearch || otherActions) && (
        <FilterWrapper $maxWidthBreakPoint={maxWidthBreakPoint}>
          {showSearch && (
            <Input
              iconLeft={
                <LensSVG onClick={onLensClick} style={{ cursor: 'pointer' }} />
              }
              placeholder="Search"
              onChange={handleOnSearchTextChange}
              value={search}
              containerStyle={{
                borderRadius: '6px',
                borderColor: theme.colors.disableText,
                padding: '5px 20px',
                minWidth: '150px',
              }}
              className="search-input"
            />
          )}
          {/* {showFilter && (
            <Popover
              trigger={
                <FilterButton size="sm" onClick={filterAction}>
                  <FilterSVG />
                  {isLargeMobile ? ' Filter' : ''}
                </FilterButton>
              }
              placement="right"
              width={width}
            >
              {filterContent || 'Add filter content'}
            </Popover>
          )}
          {showDateFilter && (
            <Popover
              trigger={
                <FilterButton size="sm" onClick={dateFilterAction}>
                  <CalenderSVG /> {isLargeMobile ? ' Filter' : ''}
                </FilterButton>
              }
              placement="right"
            >
              {dateFilterContent || 'Add date filter content'}
            </Popover>
          )} */}
          {renderAddFilterBtn('inside-filter-action-btn')}
        </FilterWrapper>
      )}
    </TitleFilterContainer>
  );
};

export default PageHeader;
